import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";

import RendertableByTitle from "./RendertableByTitle";
import {getSpecificProductAuditItemByTitle, getSpecificProductAuditItemByTitleExport } from "../../../../actions/productAuditAction";
// import ReactToPrint from "react-to-print";

import {
  Divider,
  AutoComplete,
  Row,
  Col,
  Select,
  Skeleton,
  Tabs,
  Button,
} from "antd";
import { DownloadOutlined } from '@ant-design/icons';
const { Option } = Select;

const StocklistbyTitle = ({
  getSpecificProductAuditItemByTitle,
  getSpecificProductAuditItemByTitleExport,
  reload,
  setreload,
  keyward,
  audit_health_stat,
  id,
}) => {
  var formatter = new Intl.NumberFormat("en-IN");
  const [List, setList] = useState([]);
  const [loading, setloading] = useState(false);
  let total_data = useRef({});
  const pageno = useRef(1);
  const page_size = useRef(10);



  useEffect(() => {
    setloading(false);
    getSpecificProductAuditItemByTitle(
      keyward.current,
      audit_health_stat,
      id,
      pageno.current,
      page_size.current,
    ).then((result) => {
      setList(result);
      setloading(false);
    });
  }, [reload]);

  const renderdata = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return (
        <RendertableByTitle
          List={List}
          pageno={pageno}
          page_size={page_size}
          setreload={setreload}
          reload={reload}
          setloading={setloading}
          total_data={total_data}
        />
      );
    }
  };

  return (
    <>
      <Row justify="end" style={{ marginBottom: 16 }}>
        <Col>
          <Button 
            type="primary" 
            icon={<DownloadOutlined />} 
            onClick={() => getSpecificProductAuditItemByTitleExport(keyward.current, audit_health_stat, id)}
          >
            Download Excel (Grouped)
          </Button>
        </Col>
      </Row>
      {renderdata()}
    </>
  );
};


export default connect(null, {
  getSpecificProductAuditItemByTitle,
  getSpecificProductAuditItemByTitleExport,
})(StocklistbyTitle);

